<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="txs-ctr">Originally launched on Facebook, Rupert Fawcett’s brilliantly observed, touchingly truthful <span class="epub-i">Off The Leash</span> cartoons have developed a huge daily following around the world.</p>
<p class="tx-ctr">This book brings together the very best of those cartoons, featuring the secret thoughts and conversations of dogs of every size, shape, and breed. It is a celebration of our favorite belly-scratching, tail-chasing, bed-stealing canine friends—for dog lovers everywhere.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fmtext.vue?b7b6b8c2